import React from "react";
import "./Team.scss";
import { Container, ProgressBar, Row, Col } from "react-bootstrap";
import Sandaga from "./assets/images/angry_dwarves_cover.png";
import dwarve from "../../../../assets/images/dwarve4.png";
import dwarve1 from "../../../../assets/images/dwarve1.png";
import dwarve6 from "../../../../assets/images/dwarve6.png";
import dwarve7 from "../../../../assets/images/dwarve7.png";
import yellowwave from "../../../../assets/images/yellow-wave.svg";
import yellow1 from "../../../../assets/images/yellow1.svg";
import bluewave from "../../../../assets/images/blue-wave.svg";
import blue2 from "../../../../assets/images/blue2.svg";

import Button from "react-bootstrap/Button";

import { Parallax } from "react-parallax";

const Team = () => {
  const handleRoute = () => {
    window.open("https://discord.com/invite/QTsHxHtj9k", "_blank");
  };

  return (
    <>
      <div className="team_section">
        <div className="hero_image">
          {/* <img className="sandaga_home" src={Sandaga} alt="sandaga_home"></img> */}
        </div>
        <div className="hero_text">
          {/* <h4 className="hero_headind">
    Welcome To The Mines!
  </h4>
  <p class="hero_para">Collect & Stake your Angry Dwarves & Earn Passive Income In Our $ORE Token</p> */}
        </div>
        <Container>
          <div className="mint_box">
            <Parallax
              renderLayer={(percentage) => {
                let t = percentage * 500;
              }}
            >
              <Parallax
                renderLayer={(percentage) => {
                  let t = percentage * 500;
                }}
              >
                <div className="mint_row">
                  <div className="dwarveimg">
                    {/* <img src={dwarve7} style={{ width: "80%" }} alt="" />
                    <img id="dwarve6" src={dwarve6} style={{ width: "80%" }} alt="" /> */}

                    {/* <img src={dwarve} style={{ width: "80%", marginTop: "10%" }} alt="" /> */}
                  </div>

                  {/* <div className="mint_images">
                    <img
                      className=""
                      src={dwarve}

                    />
                  </div> */}
                </div>

                <div className="mint_row">
                  <div className="dwarveimg">
                    <img src={dwarve} style={{ width: "70%" }} alt="" />
                    {/* <img src={dwarve} style={{ width: "80%", marginTop: "10%" }} alt="" /> */}
                  </div>

                  {/* <div className="mint_images">
            <img
              className=""
              src={dwarve}
            />
          </div> */}
                  <div className="mint_desc">
                    <Button
                      className="mint_heading"
                      style={{ fontSize: "1.4rem" }}
                    >
                      Staking
                    </Button>

                    <p className="mint_subheading"></p>
                    <h4 className="mint_heading">How will staking $ORE work</h4>
                    <p className="mint_para">
                      Dwarves are relentless in their accumulation of treasure
                      and will do anything to increase it. Tribe members will be
                      able to stake their Angry Dwarves NFT. Each NFT earns a
                      certain number of $ORE per day. The $ORE mined is visible
                      on the website and can be withdrawn at any time. If the
                      NFT is not staked, no $ORE will be earned.
                      <br />
                      <br />
                      There will be 3 types of ADT NFT's. These are based on
                      rarity and some give a bonus on $ORE mining.
                      <br />
                      <br />
                      Common = 100% $ORE mining
                      <br />
                      Uncommon = 125% $ORE mining
                      <br />
                      Rare = 150% $ORE mining
                    </p>
                  </div>
                </div>
              </Parallax>
            </Parallax>
          </div>

          <Parallax
            renderLayer={(percentage) => {
              let t = percentage * 800;
              let t2 = percentage * 500;
              return (
                <>
                  <div className="card_row">
                    <div
                      className="truck2"
                      style={{
                        transform: `translateX(${t2 - 380}%) translateY(${
                          t2 - 380
                        }%)`,
                      }}
                    >
                      {/* <img src={Truck2} alt="ERROR" /> */}
                    </div>
                    {/* <img src={Truck2} alt="ERROR" className="truck2" /> */}

                    {/* <img src={Astroid4} alt="ERROR" className="astroid4" /> */}
                    {/* <img src={Astroid5} alt="ERROR" className="astroid5" /> */}
                    {/* <img src={Astroid6} alt="ERROR" className="astroid6" /> */}
                    {/* <img src={Astroid7} alt="ERROR" className="astroid7" /> */}

                    {/* <img src={Truck2} alt="ERROR" className="truck2" /> */}

                    {/* <img src={Astro} alt="ERROR" className="astro" /> */}
                    {/* <img src={Planet5} alt="ERROR" className="planet5" /> */}
                    {/* <img src={Planet6} alt="ERROR" className="planet6" /> */}
                    <div
                      className="ship2"
                      style={{
                        transform: `translateX(${-t + 560}%) translateY(${
                          t - 560
                        }%)`,
                      }}
                    >
                      {/* <img src={Ship2} alt="ERROR" /> */}
                    </div>
                    {/* {
              data.map((data) => {
                return (
                  <>
                    <div className="character_card">
                      <img
                        className="char_img"
                        src={data.image}
                        alt="character_image"
                      ></img>
                      <div className="name_div">
                        <MdOutlineFingerprint
                          style={{ color: "#ff3f6d", fontSize: "20px" }}
                        />
                        <p className="character_name">{data.name}</p>
                      </div>
                      <div className="planet_div">
                        <IoPlanetOutline
                          style={{ color: "#ff3f6d", fontSize: "20px" }}
                        />
                        <p className="planet_from">{data.planet}</p>
                      </div>
                    </div>
                  </>
                )
              })
            } */}
                  </div>
                </>
              );
            }}
          ></Parallax>
          <img
            src={yellow1}
            alt=""
            style={{ width: "150%", margin: "0% 0% 0% -24%" }}
          />
        </Container>
      </div>
    </>
  );
};

export default Team;
